import React from 'react';
import PropTypes from 'prop-types';
import className from '../style.module.scss';
import {DownButton, BTN_STATUS} from '../TimerImages';
import {composeTime, splitTime} from '../Timer.utils';

/**
 * SubtractMinute
 *  - Image button to Subtract a Minute
 */
export function SubtractMinute(props) {
  const [status, setStatus] = React.useState(BTN_STATUS.DEFAULT);

  const notDisabled = () => !props.disabled;

  React.useEffect(() => {
    if (notDisabled()) setStatus(BTN_STATUS.DEFAULT);
    else setStatus(BTN_STATUS.DISABLED);
  }, [props.disabled]);

  const onReset = () => notDisabled() && setStatus(BTN_STATUS.DEFAULT);

  const onHover = () => notDisabled() && setStatus(BTN_STATUS.HOVER);

  const onPress = () => notDisabled() && setStatus(BTN_STATUS.CLICK);

  if (status === BTN_STATUS.CLICK && notDisabled()) {
    setTimeout(function () {
      const [h, m, s] = splitTime(props.time);
      props.setTime(composeTime(h, m - 1, s));
    }, props.clickInterval);
  }

  return (
    <DownButton
      status={status}
      onMouseUp={onReset}
      onMouseDown={onPress}
      onMouseEnter={onHover}
      onMouseLeave={onReset}
      className={className.timerMinuteDown}
    />
  );
}

SubtractMinute.propTypes = {
  /**
   * Time value set on the timer
   */
  time: PropTypes.instanceOf(Date),
  /**
   * Function to set timevalue
   */
  setTime: PropTypes.func,
  /**
   * Boolen to disable button
   */
  disabled: PropTypes.bool,
};

SubtractMinute.defaultProps = {
  clickInterval: 500,
};
